module.exports = __webpack_public_path__ + "static/media/4.80861a53.png";